export const TEXT = {
    substantiated_credit: `Your credit was generated with our proprietary Employee Retention Credit calculator. Click the button to download the comprehensive report.`,
    amount_under_review: `Warning: This amount is under review and may not be included in your final credit`,
};
